export const PROFILE_VIEW_SAMPLE_RATE = 0.1;

export function isActorSampled(
  actorId: string | null | undefined,
  rate: number,
): boolean {
  if (!actorId) return false;
  let hash = 2166136261;
  for (let i = 0; i < actorId.length; i++) {
    hash = Math.imul(hash ^ actorId.charCodeAt(i), 16777619);
  }
  return (hash >>> 0) / 4294967296 < rate;
}
